/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { LocalizationService } from './LocalizationService';

class LocalizationServiceProvider {
    /** @ngInject */
    constructor() {
        this.url = null;
    }

    setUrl(url) {
        this.url = url;
    }

    /** @ngInject */
    $get($http, $log) {
        return new LocalizationService($http, $log, this.url);
    }
}

export { LocalizationServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/LocalizationServiceProvider.js